const ORDINALS: string[] = ['th', 'st', 'nd', 'rd'];

export function ordinal(num: number): string {
  const rest = num % 100;
  const indicator = (ORDINALS[(rest - 20) % 10] || ORDINALS[rest] || ORDINALS[0]).toUpperCase();
  return `${num}${indicator}`;
}
